import store from '@/store';

/**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/permission/directive.vue
 */
export function checkRole(value) {
  if (value && typeof value === 'string' && value.length > 0) {
    const roles = store.getters && store.getters.roles;
    const hasPermission = roles.some(role => {
      return role.alias === value;
    });
    if (!hasPermission) {
      return false;
    }
    return true;
  } else {
    console.error(`need roles! Like v-permission="['admin','editor']"`);
    return false;
  }
}

// checkPermission('user:add'); // true/false
// checkPermission(['user:add', 'user:edit']); // 有任意一个即可 → true/false
// checkPermission({ and: ['user:add', 'user:edit'] }); // 必须都有 → true/false
// checkPermission({ or: ['user:add', 'user:edit'] }); // 任意一个 → true/false
// checkPermission({
//   and: ['user:add', { or: ['user:edit', 'user:delete'] }]
// }); // add + (edit 或 delete) → true/false
export function checkPermission(value) {
  const permissions = store.getters && store.getters.roleAuthList;
  function hasPermission(key) {
    return !!permissions[key];
  }
  function evaluate(rule) {
    if (typeof rule === 'string') {
      return hasPermission(rule);
    }
    if (Array.isArray(rule)) {
      // 默认是“或”逻辑
      return rule.some(evaluate);
    }
    if (typeof rule === 'object' && rule !== null) {
      if (rule.and && Array.isArray(rule.and)) {
        return rule.and.every(evaluate);
      }
      if (rule.or && Array.isArray(rule.or)) {
        return rule.or.some(evaluate);
      }
    }
    return false;
  }
  return evaluate(value);
}